import React from 'react';

const Loader = props => <div className='loader'></div>;

export default Loader;
